import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
    selector: 'da-customer-main',
    templateUrl: './customer-main.component.html',
    styleUrl: './customer-main.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTabNav, MatTabLink, RouterLink, RouterLinkActive, MatTabNavPanel, RouterOutlet]
})
export class CustomerMainComponent {

}
